module.exports = {"610302001":"金陵街道","610302002":"经二路街道","610302003":"清姜街道","610302004":"姜谭街道","610302005":"桥南街道","610302100":"马营镇","610302101":"石鼓镇","610302102":"神农镇","610302103":"高家镇","610302104":"八鱼镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610302.json
// module id = 2794
// module chunks = 0